import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  HostListener,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { GasMathHelper } from '@cikrf/gas-utils/helpers';
import { Subject } from 'rxjs';

import { GasModal } from '../gas-modal.interface';
import { GasModalService } from '../gas-modal.service';
import { getStyles } from '../gas-modal.helper';

@Component({
  selector: 'gas-modal',
  templateUrl: './gas-modal.component.html',
  styleUrls: ['./gas-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GasModalComponent<T = any> {
  @ViewChild('modalContent', {static: true, read: ViewContainerRef})
  public container: ViewContainerRef;

  public modal: GasModal.Modal<T>;
  public id = GasMathHelper.getUniqueId();

  public data$: Subject<T> = new Subject();

  public get hasHeader(): boolean {
    return this.modal.hasHeader ?? true;
  }

  public get modalStyle(): GasModal.ModalStyle {
    return this.modal.modalStyle;
  }

  public get modalWidthStyle(): Record<string, string> {
    if (this.modalStyle) {
      return getStyles(this.modalStyle, 'width');
    }

    return {};
  }

  public get contentHeightStyle(): Record<string, string> {
    if (this.modalStyle) {
      return getStyles(this.modalStyle, 'height');
    }

    return {};
  }

  constructor(
    private gasModalService: GasModalService<void>,
  ) { }

  @HostListener('click', ['$event'])
  /** у MouseEvent нету свойства dataset */
  public clickHandler(event: MouseEvent | any) {
    if (event.target.dataset.modal && !this.modal.isOutsideClickNotClose) {
      this.closeModal();
    }
  }

  public closeModal(): void {
    this.gasModalService.closeModal(this.id);
  }

  public confirm(): void {
    if (typeof this.modal.confirmCallback === 'function') {
      this.modal.confirmCallback();
    }
  }

  public showFooter(footer: TemplateRef<ElementRef>, closeButtonText: string): boolean {
    return !!footer || !!closeButtonText;
  }
}
